import React, {Component} from 'react'
import { useLocation } from '@reach/router'

export default function LogPageView() {
  const location = useLocation()

  React.useEffect(() => {
    console.log('log pageview', location.pathname)
    if (window && window.ga) {
      window.ga('set', 'page', location.pathname)
      window.ga('send', 'pageview')
    }
  }, [location.pathname])

  return <div/>
}
